export enum transferListViewModes {
  batchView = "batchView",
  singlesView = "singlesView",
}
